module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/compare_traffic_servers.88937464.png";